import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, connect } from 'react-redux';
import Images from '../../assets/img';
import Footer from '../BaseLayout/footer';
import { Portal, Snackbar, Alert } from '@mui/material';
import idConstants from '../../data/idConstants';
import * as Constants from '../../actions/configuration';
import { RegisterCompany } from '@mobilitystore/user-onboarding-interface';
import { getRegionCode } from '../../utils/get-region-details';
import { getEnvironment, sellerApiRestrictedRoles } from '../../utils';
import { customizedlogout } from '../../actions/LoginAction';
import { accessRoles, adfsRoles } from '../../data/appConstants';
import Loader from '../Shared/Utils/Loader';
import {
  saveUserDetails,
  submitTermsConsent,
  setUserDetails
} from '../../actions/UserRegisterAction';
import AccessDenied from '../../components/Shared/AccessDenied';
import { getUserDetails } from '../../actions/api/ApiStatisticsAction';
import isEmpty from '../../validator/isEmpty';
import EmptyPage from '../../msreact-kit/html-components/empty-page';
import { internalSellerUserOnboardingForm } from '../../data/internalSellerUserOnboardingForm';
import './index.scss';
import i18next from 'i18next';
import SalesRepDashboard from './salesRepDashBoard';
import UnifiedSellerDashboard from './UnifiedSellerDashboard';
import { getSellersList } from '../../actions/GetSellerListAction';

const Dashboard = (props) => {
  const dispatchRedux = useDispatch();
  const history = useHistory();
  const reduxStore = useSelector((state) => state);
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const [snackBarFlag, setSnackBarFlag] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState('');
  const [snackBarSeverity, setSnackBarSeverity] = useState('');
  const [loader, setLoader] = useState(false);
  const [isAdfsUserApproved, setIsAdfsUserApproved] = useState(false);
  const [userLoginRole, setUserLoginRole] = useState('');
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const userCompanyStatus = reduxStore.CompanyDetailsReducer.userCompanyStatus;
  const userRegistrationSuccessMsg =
    reduxStore.ProfileReducer.userRegistrationSuccessMsg;
  const userRegistrationErrorMsg =
    reduxStore.ProfileReducer.userRegistrationErrorMsg;
  const rolesWithoutSellerApi = sellerApiRestrictedRoles(props?.user?.roles);
  const content = reduxStore?.ContentReducer?.content;
  const isInternalSellerTenant =
    process.env.REACT_APP_SELLER_TENANT_ID === Constants.TENANT.MKOSINT;
  let registerHeading = i18next.t('HOME_PAGE.USER_STATUS.REGISTER_COMPANY');
  let registerDescription = i18next.t(
    'HOME_PAGE.USER_STATUS.PENDING_REG_DESCRIPTION'
  );
  let dynamicForm = '';
  const [sellerList, setSellerList] = useState([]);
  const role = props?.user?.roles?.[0];

  if (isInternalSellerTenant) {
    registerHeading = i18next.t('INTERNAL_SELLER.REGISTER_NOW');
    registerDescription = '';
    dynamicForm = internalSellerUserOnboardingForm(userCompanyStatus);
  }

  const openPopUp = () => {
    setOpenRegisterModal(true);
    if (window.location.pathname !== '/dashboard') {
      history.push('/dashboard');
    }
  };

  const RegisterComponent = localStorage.getItem(idConstants.tokens.aaaIdToken) &&
    (isInternalSellerTenant
      ? userCompanyStatus?.companyRegisteredStatus !==
        idConstants.approved.description.toLowerCase()
      : true) &&
    openRegisterModal && (
      <RegisterCompany
        language='en'
        clientToken={localStorage.getItem(idConstants.tokens.aaaIdToken)}
        environment={getEnvironment(process.env.REACT_APP_ENVIRONMENT)}
        successHandler={(response) => handleSuccessResponse(response)}
        cancelHandler={() => {
          setOpenRegisterModal(false);
        }}
        errorHandler={(error) => {
          if (error.message) {
            setSnackBarFlag(true);
            setSnackBarMsg(error.message);
            setSnackBarSeverity('error');
          }
        }}
        role={Constants.AAA_CONFIG.SELLER_ROLE}
        regionCode={getRegionCode()}
        fontName='boschsans'
        dynamicForm={dynamicForm}
      />
    );

  useEffect(() => {
    if (role === accessRoles.sales_rep && isAdfsUserApproved) {
      const regionCode = getRegionCode();
      dispatchRedux(getSellersList(regionCode, 0, 1000, 'approved')).then(
        (response) => {
          setSellerList(response?.users);
        }
      );
    }
  }, [isAdfsUserApproved]);

  useEffect(() => {
    if (isEmpty(userRegistrationSuccessMsg)) return;
    setSnackBarFlag(true);
    setSnackBarMsg(userRegistrationSuccessMsg);
    setSnackBarSeverity('success');
    setLoader(false);
    dispatchRedux({
      type: 'USER_REGISTRATION_SUCCESS_ALERT',
      payload: ''
    });
  }, [userRegistrationSuccessMsg]);

  useEffect(() => {
    if (isEmpty(userRegistrationErrorMsg)) return;
    setSnackBarFlag(true);
    setSnackBarMsg(userRegistrationErrorMsg);
    setSnackBarSeverity('error');
    setLoader(false);
    dispatchRedux({
      type: 'USER_REGISTRATION_ERROR_ALERT',
      error: ''
    });
  }, [userRegistrationErrorMsg]);

  const handleSuccessResponse = (response) => {
    if (isInternalSellerTenant) {
      const userDetails = {};
      userDetails.firstName = response.companyData.userData.firstName;
      userDetails.lastName = response.companyData.userData.lastName;
      userDetails.contactNo =
        response.companyData.userData.isdCode +
        ' ' +
        response.companyData.userData.phoneNo;
      userDetails.countryCode = 'IN';
      userDetails.roleName = Constants.AAA_CONFIG.SELLER_ROLE;
      setLoader(true);
      dispatchRedux(setUserDetails(userDetails));
      saveUserDetails(userDetails, dispatchRedux).then((res) => {
        if (res.data.userId) {
          dispatchRedux(getUserDetails());
          dispatchRedux(submitTermsConsent());
        }
      });
    } else if (!isEmpty(response?.companyRegStatusDescription)) {
      dispatchRedux({
        type: 'USER_COMPANY_STATUS',
        payload: {
          ...userCompanyStatus,
          companyRegStatusDescription: response.companyRegStatusDescription,
          companyRegisteredStatus: response.status
        }
      });
    }
  };

  useEffect(() => {
    setLoader(true);
    if (Array.isArray(props?.user?.roles)) {
      if (adfsRoles.some((role) => props.user?.roles?.includes(role))) {
        setIsAdfsUserApproved(true);
      }
      if (props.user?.roles?.includes(accessRoles.csm))
        history?.push('/dashboard/place-order');
      setLoader(false);
    }
  }, [props?.user?.roles]);

  useEffect(() => {
    const storedUserLoginRole = props?.user?.roles?.[0];
    const storedUserLoginIdp = localStorage.getItem(idConstants.userLoginIdp);
    if (storedUserLoginRole) {
      setUserLoginRole(storedUserLoginRole);
    }
    if (
      storedUserLoginIdp === idConstants.idp.skid &&
      props?.user?.emailId?.toLowerCase().includes('bosch.com')
    ) {
      setShowAccessDenied(true);
    }
  }, [props?.user]);

  const handleCustomizedLogout = () => {
    dispatchRedux(customizedlogout());
  };

  const isCompanyApproved =
    userCompanyStatus?.companyRegisteredStatus === 'approved' &&
    userCompanyStatus?.areCompanyDetailsCaptured === true;

  return (
    <div>
      <div>{loader && <Loader />}</div>
      <div>
        {showAccessDenied ? (
          <AccessDenied
            show={true}
            signOut={handleCustomizedLogout}
            details={content?.components?.login?.seller_access_denied}
          />
        ) : (
          <div
            style={{
              backgroundImage:
                isCompanyApproved === true && Constants.IS_MKOSINT_TENANT
                  ? `url(${Images.backgroundDashboard})`
                  : ''
            }}
            className={`${Constants.IS_MKOSINT_TENANT ? 'dashboard-container' : 'dashboard-height'} ${
              !isCompanyApproved && !isAdfsUserApproved ? 'image-container' : ''
            } ${isCompanyApproved && !isAdfsUserApproved ? 'dashboard-center-align' : ''} `}
          >
            {loader && <Loader />}
            {(userCompanyStatus || rolesWithoutSellerApi?.length > 0) && (
              <div
                className={`${Constants.IS_MKOSINT_TENANT ? 'content-container' : ''}`}
              >
                {(() => {
                  if (isCompanyApproved === false && !isAdfsUserApproved) {
                    return (
                      <EmptyPage
                        label={registerHeading}
                        disabled={false}
                        showPrimaryButton={
                          !userCompanyStatus?.companyRegisteredStatus
                        }
                        showNote={true}
                        note={
                          userCompanyStatus?.companyRegisteredStatus
                            ? userCompanyStatus?.companyRegStatusDescription
                            : registerDescription
                        }
                        heading={
                          userCompanyStatus?.companyRegisteredStatus
                            ? userCompanyStatus?.companyRegisteredStatus.replace(
                                '_',
                                ' '
                              )
                            : i18next.t('HOME_PAGE.USER_STATUS.PENDING')
                        }
                        handleClick={() => openPopUp()}
                        isHideEmpty={true}
                      />
                    );
                  } else if (
                    userLoginRole === accessRoles.sales_rep &&
                    isAdfsUserApproved
                  ) {
                    return <SalesRepDashboard {...props} sellerList={sellerList} />;
                  }
                  return (
                    <>
                      {!Constants.IS_MKOSINT_TENANT ? (
                        <UnifiedSellerDashboard />
                      ) : (
                        <>
                          <img
                            src={Images.monitor}
                            alt=''
                            className='image-dashboard'
                          />
                          <div className='dashboard-text'>
                            {i18next.t('DYNAMIC_FORM.DASHBOARD.TEXT_1')}
                            <br />
                            {i18next.t('DYNAMIC_FORM.DASHBOARD.TEXT_2')}
                          </div>
                        </>
                      )}
                    </>
                  );
                })()}
              </div>
            )}
            {RegisterComponent}
            <Portal>
              {snackBarFlag && snackBarMsg && (
                <Snackbar
                  open={snackBarFlag}
                  autoHideDuration={3000}
                  onClose={() => {
                    setSnackBarFlag(false);
                    setSnackBarMsg('');
                    setSnackBarSeverity('');
                  }}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                  <Alert severity={snackBarSeverity}>{snackBarMsg}</Alert>
                </Snackbar>
              )}
            </Portal>
            <Footer customClassName='d-lg-none' />
          </div>
        )}
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  user: PropTypes.shape({
    emailId: PropTypes.string,
    roles: PropTypes.array
  })
};

const mapStateToProps = (redux_state) => ({
  user: redux_state.loginReducer.user
});

export default connect(mapStateToProps)(Dashboard);
